@if (this.workflowService.workflowId()) {
<div class="custom-full-height">
    <div class="grid-item flex-column" id="page-title">
        <!-- Welcome -->
        <div class="flex-row">
            <div class="title-text lower-margin">
                Hi, <strong>upload your contract to get started.</strong><br />
                <!-- BMW Proposal: Implementation of self-driving car -->
            </div>
        </div>
        <div class="label-text">To get started, please upload your contract</div>
        <!-- <div class="ten-grid-container grid-row-number card-style lower-margin"> -->

        <div class="upload-wrapper">

            <mat-expansion-panel [expanded]="true">
                <mat-expansion-panel-header>
                    <b>Dokumenten-Upload</b>
                </mat-expansion-panel-header>

                <div class="upload-wrapper">
                    <h3>Analysetyp auswählen</h3>
                    <shared-upload [workflowId]="workflowService.workflowId()!" workflowType="documents" [fileList]="workflowService.fileList()" [fileLimit]="15" [fileFormats]="data.fileFormats" (fileProcessEvent)="updateFileData($event)" (deleteFileEvent)="deleteFileData($event)"></shared-upload>

                </div>
            </mat-expansion-panel>
        </div>

        <div class="ten-grid-container grid-row-number card-style">
            <div class="subtitle-text grid-item" id="context-title">Prompt Context</div>
            <div class="grid-item" id="prompt-context">
                <textarea rows="2" class="input" placeholder="Define the prompt context..." [ngModel]="this.workflowService.promptContext()" (ngModelChange)="updatePromptContext($event, 'promptContext')" style="overflow: auto; resize: both;"></textarea>
            </div>
            <div class="subtitle-text grid-item" id="prompt-title">Prompt</div>
            <div class="grid-item lower-margin" id="prompt">
                <textarea rows="10" class="input" placeholder="Define the prompt..." [ngModel]="this.workflowService.prompt()" (ngModelChange)="updatePromptContext($event, 'prompt')" style="overflow: auto; resize: both;"></textarea>
            </div>
        </div>
        @if (this.workflowService.fileList()) {
        <div class="button-container flex-row align-center lower-margin">
            <button mat-flat-button color="primary" (click)="savePrompt()">
                Save Prompt
            </button>
            <div [style.width.px]="10"></div>
            <button mat-flat-button color="primary" (click)="testPrompt()">
                Test Prompt
            </button>
        </div>

        <div class="lower-margin">
            @for (section of (this.workflowService.specifications()?.promptResults ?? []); track section) {
            <div class="label-text">Result:</div>
            <div class="ten-grid-container grid-row-number card-style lower-margin-small">
                <div class="subtitle-text grid-item" id="result-title">File Number: {{section.file}}</div>
                <div class="grid-item lower-margin" id="result">
                    <pre style="white-space: pre-wrap; word-wrap: break-word;">{{ section.promptResult }}</pre>
                </div>
            </div>
            }
        </div>
        }

    </div>
</div>
}